import type { Permission } from '@cobliteam/permissions';
import type { RouteDef } from '../../../dashboardDef.type';

const getRoutesWithPermission = (routesDef: RouteDef[], isAccessAllowed: (permission: Permission) => boolean) => {
  const routesDefWithPermission = routesDef.filter((nav) => {
    if (!nav.permission) return false;

    if (nav.routes) {
      nav.routes = nav.routes.filter((route) => {
        if (route.routes) {
          route.routes = route.routes.filter((group) => isAccessAllowed(group.permission as Permission));
        }
        return isAccessAllowed(route.permission as Permission);
      });

      return nav.routes.length > 0;
    }

    return isAccessAllowed(nav.permission as Permission);
  });

  return routesDefWithPermission;
};

export default getRoutesWithPermission;
